module.exports = __webpack_public_path__ + "static/36-thumb-152f940ab093db77c8c528718604d024.jpg";